import styled from "styled-components";
import Configurateur from "./components/Configurateur/Configurateur";
import ConfigurateurHeaderContainer from "./components/Configurateur/ConfigurateurHeaderContainer";
import {device} from "./helper/constants";

const Wrapper = styled.div`
    min-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  
`;
const ConfigurateurContainer = styled.div`
    width: 100%;
    margin-top: -50px;
    padding-left: 20px;
    padding-right: 20px;
    &.md {
      margin-top: 0;
    }

      @media ${device.tablet} {
        padding: 0;
      }
`;

const AppStepForm = ({mid, mode}) => {
    return (
        <Wrapper>
            <ConfigurateurHeaderContainer mode={mode}/>
            <ConfigurateurContainer className={mode ? 'md' : ''}>
                <Configurateur mid={mid} mode={mode}/>
            </ConfigurateurContainer>
        </Wrapper>
    );
};
export default AppStepForm;
